const quoteToAssignReport = {
  label: "Quote To Assign Report",
  name: "quoteToAssignReport",
  parameters: [
    {
      name: "db",
      label: "Database",
      type: "select",
      defaultValue: "hero",
      options: [
        { key: "hero", label: "HERO" },
        { key: "data", label: "DATA" },
      ],
    },
  ],
};

export default quoteToAssignReport;
